import { LinkedIn, GitHub, Instagram, Facebook, Mail } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'

interface Props { }

function SocialLink(props: Props) {
    const { } = props
    function goTo(link: string) {
        window.open(link)
    }

    return (

        <Box gap={1} display={"flex"}>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='info'><LinkedIn /></IconButton>
            {/* <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='inherit'><GitHub /></IconButton> */}
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='error'><Instagram /></IconButton>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='info'><Facebook /></IconButton>
            <IconButton style={{backgroundColor: "rgba(255, 255, 255, 1)", padding: "5px"}} onClick={() => { goTo("") }} color='error'><Mail /></IconButton>
        </Box>
    )
}

export default SocialLink
